import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type ChevronRightIconProps = Partial<SVGIconProps>;
const ChevronRightIcon: FC<ChevronRightIconProps> = (props) => {
  return (
    <SVGIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M8.90991 19.92L15.4299 13.4C16.1999 12.63 16.1999 11.37 15.4299 10.6L8.90991 4.08"
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </SVGIcon>
  );
};

export default ChevronRightIcon;
